const c = [
  ["OC", "/"],
  ["US", "us/"],
  ["DE", "de/"],
  ["CO", "co/"],
  ["AU", "au/"],
  ["NZ", "nz/"],
  ["IN", "in/"],
  ["PT", "pt/"],
  ["ZA", "za/"],
  ["KE", "ke/"],
  ["NG", "ng/"],
  ["NL", "nl/"],
  ["FR", "fr/"],
  ["SE", "se/"],
  ["SM", "sm/"],
  ["CX", "cx/"],
  ["CA", "ca/"],
  ["ES", "es/"],
  ["IT", "it/"],
  ["BR", "br/"],
  ["GZ", "/"],
  ["WS", "/"]
];
function u(e, r) {
  const t = c.find(([a]) => a === e);
  if (!t) return r ? "/" : "";
  const n = t[1];
  return n === "/" ? r ? "/" : "" : `/${n.replace(/\/$/, "")}`;
}
function s(e) {
  return u(e, !1);
}
function f(e) {
  return u(e, !0);
}
export {
  s as a,
  f as g,
  c as r
};
